import styled from 'styled-components';

import media from 'apps/auth/theme/media';
import zIndex from 'apps/auth/theme/zIndex';

interface ModalBodyProps {
    fullSizeModal?: boolean;
    hasBottomPanel?: boolean;
    isVerticalCentered?: boolean;
}

const shouldForwardModalBodyProp = (prop: string) => !['fullSizeModal', 'hasBottomPanel', 'isVerticalCentered'].includes(prop);

export const ModalContainer = styled.div`
    background-color: ${(props) => props.theme.grey_28_tr};
    bottom: 0;
    left: 0;
    min-width: 288px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: ${zIndex.modalIndex};
`;
export const ModalViewport = styled.div`
    background-color: ${(props) => props.theme.white};
    bottom: 0;
    color: ${(props) => props.theme.black};
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    right: 0;
    top: 0;
`;
export const ModalBody = styled.div.withConfig({ shouldForwardProp: shouldForwardModalBodyProp })<ModalBodyProps>`
    padding: ${(props) => (props.fullSizeModal ? '0' : props.hasBottomPanel ? '72px 24px 128px 24px' : '72px 24px 64px 24px')};
    margin: 0 auto;
    /* content width 480 */
    max-width: ${(props) => (props.fullSizeModal ? '100%' : '528px')};
    min-height: 100%;
    height: ${(props) => (props.fullSizeModal ? '100%' : null)};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => (props.isVerticalCentered ? 'center' : 'flex-start')};

    ${media.tablet720} {
        padding: ${(props) => (props.fullSizeModal ? '0' : '128px 24px')};
        /* content width 504px */
        max-width: ${(props) => (props.fullSizeModal ? '100%' : '552px')};
    }
`;
